import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
export function useResultCategoryOutletContext(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.sideImage, sideImage = _c === void 0 ? '' : _c, _d = _b.step, step = _d === void 0 ? 0 : _d, _e = _b.heading, heading = _e === void 0 ? null : _e, _f = _b.nav, nav = _f === void 0 ? null : _f;
    var _g = useOutletContext(), setImage = _g.setImage, setHeading = _g.setHeading, setNav = _g.setNav, setStep = _g.setStep;
    useEffect(function () {
        if (sideImage)
            setImage(sideImage);
        if (heading)
            setHeading(heading);
        if (step)
            setStep(step);
        if (nav)
            setNav(nav);
        return function () {
            setImage('');
            setHeading(null);
            setNav(null);
            setStep(0);
        };
    }, []);
    return { setImage: setImage, setHeading: setHeading, setNav: setNav, setStep: setStep };
}
